import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Resolve } from "@angular/router";
import { Observable, from } from "rxjs";

import { DbService } from "./db.service";
import { Map } from "../interfaces/map";
import { AppStateService } from '../appState.service';

@Injectable({
    providedIn: 'root'
})
export class MapResolver implements Resolve<Map> {

    constructor(
        private db: DbService,
        private appState: AppStateService,
    ) { }

    public resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<Map> {
        if (route.params.id === "tutorial") {
            return from(this.db.getTutorial().catch(e => {
                console.error("couldn't retrieve tutorial", e);
                return e.status;
            }))
        } else {
            return from(this.db.getUserMap(route.params.id, true, this.appState.getLanguage()).catch(e => {
                console.error("couldn't retrieve map", e);
                return e.status;
            }));
        }
    }
}
